/* istanbul ignore file */
import { MediumFormRow as FormRow, FormSection } from 'framework/ui/layout';
import { useShowContext } from 'framework/show';
import { useMessageService, SuccessMessage } from 'framework/ui/Message';
import { ModalForm, DateInput } from 'framework/form';
import { useEmployeeNamesService, NotDismissedEmployeeInput } from 'domain/shared/employee';
import useAssetService from '../useAssetService';

interface AssignAssetOwnerFormProps {
  closeModal: () => void;
  modalOpen: boolean;
}

const getValidationSchema = () =>
  Promise.resolve({
    assignmentDetails: {
      type: 'object',
      _divisible: false,
      properties: {
        currentOwner: {
          type: 'string',
          required: true,
        },
        provisionDate: {
          type: 'date',
          required: true,
          maxDate: {
            value: '$TODAY',
            message: 'Please choose date not earlier than today',
          },
        },
      },
    },
  });

const AssignAssetOwnerForm = ({ closeModal, modalOpen }: AssignAssetOwnerFormProps) => {
  const { data: asset, setData = () => {} } = useShowContext();
  const { addMessage } = useMessageService();
  const assetId = asset.getValueBySource('inventoryNumber');
  const { updateAssignmentDetails } = useAssetService();
  const { getEmployeeNameDataById } = useEmployeeNamesService();

  const getDataFunc = async () => {
    const assignmentDetails = asset.getValueBySource('assignmentDetails');

    if (assignmentDetails?.currentOwner) {
      try {
        const employeeName = (await getEmployeeNameDataById(assignmentDetails.currentOwner)) || {};
        const currentOwnerName = employeeName.nameEn;
        assignmentDetails.currentOwnerFullName = `${assignmentDetails.currentOwner} ${
          currentOwnerName?.firstName || ''
        } ${currentOwnerName?.lastName || ''}`.trim();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }

    return {
      assignmentDetails,
    };
  };

  return (
    <ModalForm
      closeModal={closeModal}
      modalOpen={modalOpen}
      submitFormFunc={data => updateAssignmentDetails(assetId, data)}
      afterSubmit={{
        execute: response => {
          setData(response);
          addMessage(new SuccessMessage('Current Owner has been successfully updated.'));
        },
      }}
      getDataFunc={getDataFunc}
      getValidationSchemaFunc={getValidationSchema}
    >
      <FormSection>
        <FormRow>
          <NotDismissedEmployeeInput
            source="assignmentDetails.currentOwner"
            nameSource="assignmentDetails.currentOwnerFullName"
            label="Current owner"
            includeContractors
          />
          <DateInput source="assignmentDetails.provisionDate" label="Provision date" />
        </FormRow>
      </FormSection>
    </ModalForm>
  );
};

export default AssignAssetOwnerForm;
